






















































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import authModel from "@/models/auth.model";
import { validateEntity } from "@/models/entity-validation";

import EntityField from "@/layouts/components/EntityField.vue";
import Logo from "@/layouts/components/Logo.vue";
import TermsPopup from "@/layouts/components/TermsPopup.vue";


type Tab = { name: string, fields: { key: string, class: string, required?: boolean }[], errors: { [key: string]: string | undefined }};

@Component({
  components: {
    EntityField,
    TermsPopup,
    Logo
  }
})
export default class Login extends Vue {
  components: {
    FormWizard: any;
    TabContent: any;
  };

  email = "";
  password = "";
  matchPassword = "";
  checkbox_remember_me = false;
  checkBoxTerms = false;
  popupActive = false;

  userEntityDescription: any[] = [];
  userEntity: any = { termsConsent: false };

  tabs: Tab[] = [
    {
      name: "Etapa 1",
      fields: [
        { key: "name", class: "vx-col md:w-full w-full my-2", required: true },
        { key: "companyName", class: "vx-col md:w-1/2 w-full my-2" },
        { key: "taxDocumentNumber", class: "vx-col md:w-1/2 w-full my-2", required: true },
        { key: "email", class: "vx-col md:w-1/2 w-full my-2", required: true },
        { key: "websiteUrl", class: "vx-col md:w-1/2 w-full my-2" },
      ],
      errors: {},
    },
    {
      name: "Etapa 2",
      fields: [
        { key: "addressStreet", class: "vx-col md:w-full w-full my-2", required: true },
        { key: "addressPostalCode", class: "vx-col md:w-1/2 w-full my-2", required: true },
        { key: "addressDistrict", class: "vx-col md:w-1/2 w-full my-2", required: true },
        { key: "addressCity", class: "vx-col md:w-1/2 w-full my-2", required: true },
        { key: "addressState", class: "vx-col md:w-1/2 w-full my-2", required: true },
        { key: "phoneNumber", class: "vx-col md:w-1/2 w-full my-2" },
        { key: "cellphoneNumber", class: "vx-col md:w-1/2 w-full my-2" },
      ],
      errors: {},
    },
    {
      name: "Etapa 3",
      fields: [
        { key: "logoUrl", class: "vx-col d-flex md:w-full w-full my-2" },
        { key: "password", class: "vx-col md:w-1/2 w-full my-2", required: true },
        { key: "passwordConfirmation", class: "vx-col md:w-1/2 w-full my-2", required: true },
        { key: "termsConsent", class: "vx-col w-full my-2", required: true },
      ],
      errors: {},
    },
  ];

  async mounted() {
    await this.$vs.loading();
    try {
      this.userEntityDescription = await authModel.getUserDescription();
      // add password confirmation field definition
      this.userEntityDescription.push({
        key: 'passwordConfirmation',
        name: 'Confirmar senha',
        kind: 'password',
        validation: { kind: 'match', matchKey: 'password' },
      });
      // add consent checkbox field definition
      this.userEntityDescription.push({
        key: 'termsConsent',
        name: 'Li e concordo com a Política de Uso e Privacidade',
        kind: 'checkbox',
        validation: {},
      });
      // enable reactivity for entity properties
      this.userEntityDescription.forEach(field => this.$set(this.userEntity, field.key, undefined));
    } catch (error) {
      console.error(error);
      this.$vs.notify({ color: "danger", title: "Erros encontrados", text: "Ocorreu um erro ao carregar a página. Verifique sua conexão e tente novamente." });
    }
    await this.$vs.loading.close();
  }

  async signup() {
    this.$vs.loading();
    try {
      const filteredUser = Object.fromEntries(Object.entries(this.userEntity).map(([key, value]) => [key, value === "" ? null : value])); // turn empty strings into null
      await authModel.signup({ ...filteredUser, passwordConfirmation: undefined, termsConsent: undefined });
      this.popupActive = true;
      this.$vs.notify({ color: "success", title: "Sucesso", text: "Seus dados foram enviados" });
    } catch (error) {
      console.error(error);
      if (error.message === "Conflict") {
        this.$vs.notify({ color: "danger", title: "Cadastro existente", text: "Seu CNPJ, CPF ou e-mail já estão cadastrados. Faça o login com seu e-mail e senha." });
      } else {
        this.$vs.notify({ color: "danger", title: "Ocorreu um erro", text: "Verifique os dados informados e tente novamente" });
      }
    }
    this.$vs.loading.close();
  }

  validateTab(tab: Tab, errorWarning = false) {
    const requiredKeys = tab.fields.filter(field => field.required).map(field => field.key);
    tab.errors = validateEntity(this.userEntity, this.userEntityDescription, requiredKeys);
    // block tab change if errors are present
    for (const field of tab.fields) {
      if (tab.errors[field.key]) {
        if (errorWarning) {
          this.$vs.notify({ color: "danger", title: "Erros encontrados", text: "Corrija os erros indicados para prosseguir" });
        }
        return false;
      }
    }
    return true;
  }

  consented = false;

  @Watch('userEntity', { deep: true })
  userEntityChanged() {
    this.tabs.forEach((tab) => {
      // if a previous error was found, update validation when data changes
      if (Object.keys(tab.errors).length) {
        this.validateTab(tab);
      }
    });
    if (!this.consented && this.userEntity.termsConsent) {
      (this.$refs.termsPopup as any).showPopup();
    }
    this.consented = this.userEntity.termsConsent;
  }
}
